<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  components: {},
};
</script>
<style>
#app {
  width: 100%;
}
.wrap {
  min-width: 1400px;
  /* min-width: 1440px; */
}
* {
  margin: 0;
  padding: 0;
  /* font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif; */
}
</style>
